export const appGlobals = {
    ashaBrandBlockLongPath: '/assets/img/AALZ-Brand-Block-Color-Long.svg',
    ApiTimeoutInSeconds: 15,
    cacheExpirationInMinutes: 100,
    educationalEntitiesCacheTimeoutInDays: 30,
    genericProfilePhotoPath: '/assets/img/generic-profile.webp',
    phoneScreenMaxWidthInPixels: 575,
    profileReminderPeriodInDays: 30,
    uploadFileNameMaxLength: 99,
}